export { default } from "-!./Edit.ts?vue&type=script&lang=ts&external"; export * from "-!./Edit.ts?vue&type=script&lang=ts&external"